import Enums from "../../../src/enums/enums";
export default {
  ToContactNameList(_contactList) {
    let contactList = [];
    if (_contactList !== null) {
      for (let i = 0; i < _contactList.length; i++) {
        let contactData = {
          id: _contactList[i].id,
          contactBranchCode: _contactList[i].contactBranchCode,
          contactCode: _contactList[i].contactCode,
          contactFullName: _contactList[i].contactFullName,
          status: "null",
        };
        contactList.push(contactData);
      }
    }
    return contactList;
  },
  ToContactList(_contactList) {
    let contactList = [];
    if (_contactList !== null) {
      for (let i = 0; i < _contactList.length; i++) {
        let contactData = {
          id: _contactList[i].id,
          contactBranchCode: _contactList[i].contactBranchCode,
          contactTaxId: _contactList[i].contactTaxId,
          contactCode: _contactList[i].contactCode,
          contactFullName: _contactList[i].contactFullName,
          contactFullNameEng: _contactList[i].contactFullNameEng,
          contactFullNameTh: _contactList[i].contactFullNameTh,
          contactShortName: _contactList[i].contactShortName,
          contactShortNameEng: _contactList[i].contactShortNameEng,
          contactShortNameTh: _contactList[i].contactShortNameTh,
          contactName: _contactList[i].contactName,
          contactType: _contactList[i].contactType,
          country: _contactList[i].country,
          incomeDueDateTypeId: _contactList[i].incomeDueDateTypeId,
          incomeDueDateDay: _contactList[i].incomeDueDateDay,
          outflowDueDateTypeId: _contactList[i].outflowDueDateTypeId,
          outflowDueDateDay: _contactList[i].outflowDueDateDay,
          address: _contactList[i].address,
          phoneNumber: _contactList[i].contactPhoneNumber,
          email: _contactList[i].contactEmail,
          webSite: _contactList[i].contactWebSite,
          personFirstName: _contactList[i].personFirstName,
          personLastName: _contactList[i].personLastName,
          personNickName: _contactList[i].personNickName,
          personEmail: _contactList[i].personEmail,
          personPhone: _contactList[i].personPhone,
          contactWhtType: _contactList[i].contactWhtType,
          status: "null",
          logoUrl: _contactList[i].logoUrl,
          accountsPayableAccountId: _contactList[i].accountsPayableAccountId,
          accountsReceivableAccountId: _contactList[i].accountsReceivableAccountId,
          isDeleted: _contactList[i].isDeleted,
          isArchived: _contactList[i].isArchived,
          isFavorite: false,
          sortNumber: 0,
          isSuggest: false,
          creditLimit: _contactList[i].creditLimit,
          creditLimitSettingType: _contactList[i].creditLimitSettingType,
        };
        contactList.push(contactData);
      }
    }
    return contactList;
  },
  ToContactSearchFirst(_contactList) {
    let contactList = [];
    if (_contactList !== null) {
      for (let i = 0; i < _contactList.length; i++) {
        let contactData = {
          contactBranchCode: _contactList[i].contactBranchCode,
          contactCode: _contactList[i].contactCode,
          contactEmail: _contactList[i].contactEmail,
          contactFirstName: _contactList[i].contactFirstName,
          contactFullName: _contactList[i].contactFullName,
          id: _contactList[i].contactId,
          contactLastName: _contactList[i].contactLastName,
          contactName: _contactList[i].contactName,
          contactNickName: _contactList[i].contactNickName,
          contactPersonEmail: _contactList[i].contactPersonEmail,
          contactPersonPhone: _contactList[i].contactPersonPhone,
          contactPhone: _contactList[i].contactPhone,
          contactShortName: _contactList[i].contactShortName,
          contactTaxId: _contactList[i].contactTaxId,
          contactType: _contactList[i].contactType,
          contactWebsite: _contactList[i].contactWebsite,
          personalNamePrefixOther: _contactList[i].personalNamePrefixOther,
          personalNamePrefixTypeId: _contactList[i].personalNamePrefixTypeId,
        };
        contactList.push(contactData);
      }
    }
    return contactList;
  },
  ToSearchedContactAddress(_contactAddress) {
    let contactAddress = {
      addressSource: _contactAddress.addressSource,
      addressType: _contactAddress.addressType,
      branchCode: _contactAddress.branchCode,
      building: _contactAddress.building,
      contactTemplateBranchId: _contactAddress.contactTemplateBranchId,
      contactTemplateId: _contactAddress.contactTemplateId,
      country: _contactAddress.country,
      district: _contactAddress.district,
      email: _contactAddress.email,
      fax: _contactAddress.fax,
      floorNo: _contactAddress.floorNo,
      homeGroup: _contactAddress.homeGroup,
      homeNo: _contactAddress.homeNo,
      isVat: _contactAddress.isVat,
      merchantType: _contactAddress.merchantType,
      name: _contactAddress.name,
      no: _contactAddress.no,
      personalNamePrefixTypeId: _contactAddress.personalNamePrefixTypeId,
      personalNamePrefixTypeOther: _contactAddress.personalNamePrefixTypeOther,
      phone: _contactAddress.phone,
      postCode: _contactAddress.postCode,
      province: _contactAddress.province,
      road: _contactAddress.road,
      roomNo: _contactAddress.roomNo,
      soi: _contactAddress.soi,
      subDistrict: _contactAddress.subDistrict,
      taxId: _contactAddress.taxId,
      updateDateTime: _contactAddress.updateDateTime,
      website: _contactAddress.website,
      logoUrl: _contactAddress.logoUrl,
      verificationStatus: _contactAddress.verificationStatus,
    };
    return contactAddress;
  },
  ToContactDetail(_contactDetail) {
    let contactDetail = {
      id: _contactDetail.id,
      contactFinanceType: _contactDetail.contactFinanceType,
      name: _contactDetail.name,
      isVat: _contactDetail.isVat,
      email: _contactDetail.email,
      phone: _contactDetail.phone,
      address: _contactDetail.address,
      merchantType: _contactDetail.merchantType,
      contactName: _contactDetail.contactName,
      fax: _contactDetail.fax,
      website: _contactDetail.website,
      code: _contactDetail.code,
      invoiceIncomeType: _contactDetail.invoiceIncomeType,
      invoiceIncomeValue: _contactDetail.invoiceIncomeValue,
      accountsReceivableAccountId: _contactDetail.accountsReceivableAccountId,
      invoiceExpenseType: _contactDetail.invoiceExpenseType,
      invoiceExpenseValue: _contactDetail.invoiceExpenseValue,
      accountsPayableAccountId: _contactDetail.accountsPayableAccountId,
      personalNamePrefixType: _contactDetail.personalNamePrefixType,
      personalNamePrefixOther: _contactDetail.personalNamePrefixOther,
      contactCreditLimit: _contactDetail.contactCreditLimit,
      creditLimitSettingType: _contactDetail.creditLimitSettingType,
      logoUrl: _contactDetail.logoUrl,
      taxId: _contactDetail.taxId,
      isDeleted: _contactDetail.isDeleted,
      isArchived: _contactDetail.isArchived,
      bankInformation: _contactDetail.bankInformation,
      personToContact: _contactDetail.personToContact
        ? _contactDetail.personToContact.filter((x) => x.isMainPerson)
        : _contactDetail.personToContact,
      contactBranchModel: _contactDetail.contactBranchModel,
      groupList: _contactDetail.groupList,
    };
    return contactDetail;
  },
  ToContactWhtTypeSuggestWhtPercentList(_contactWhtTypeSuggestWhtPercents) {
    let contactWhtTypeSuggestWhtPercents = [];
    if (_contactWhtTypeSuggestWhtPercents !== null) {
      for (let i = 0; i < _contactWhtTypeSuggestWhtPercents.length; i++) {
        let contactData = {
          contactWhtType: _contactWhtTypeSuggestWhtPercents[i].contactWhtType,
          taxIncomeTypeContactWhtTypeModels: [],
        };
        for (let j = 0; j < _contactWhtTypeSuggestWhtPercents[i].taxIncomeTypeContactWhtTypeModels.length; j++) {
          let contactDataModel = {
            id: _contactWhtTypeSuggestWhtPercents[i].taxIncomeTypeContactWhtTypeModels[j].id,
            code: _contactWhtTypeSuggestWhtPercents[i].taxIncomeTypeContactWhtTypeModels[j].code,
            name: _contactWhtTypeSuggestWhtPercents[i].taxIncomeTypeContactWhtTypeModels[j].name,
            nameEn: _contactWhtTypeSuggestWhtPercents[i].taxIncomeTypeContactWhtTypeModels[j].nameEn,
            whtPercent: _contactWhtTypeSuggestWhtPercents[i].taxIncomeTypeContactWhtTypeModels[j].whtPercent,
          };
          contactData.taxIncomeTypeContactWhtTypeModels.push(contactDataModel);
        }
        contactWhtTypeSuggestWhtPercents.push(contactData);
      }
      return contactWhtTypeSuggestWhtPercents;
    }
  },
  ToContactPersonDetailList(_contactPersonDetailModel) {
    let contactPersonList = [];
    if (_contactPersonDetailModel !== null) {
      for (let i = 0; i < _contactPersonDetailModel.length; i++) {
        let contactPersonData = {
          contactPersonId: _contactPersonDetailModel[i].contactPersonId,
          namePrefix: _contactPersonDetailModel[i].namePrefix,
          personalNamePrefixTypeId: _contactPersonDetailModel[i].personalNamePrefixTypeId,
          firstname: _contactPersonDetailModel[i].firstname,
          lastname: _contactPersonDetailModel[i].lastname,
          nickname: _contactPersonDetailModel[i].nickname,
          departmentName: _contactPersonDetailModel[i].departmentName,
          departmentTypeId: _contactPersonDetailModel[i].departmentTypeId,
          position: _contactPersonDetailModel[i].position,
          email: _contactPersonDetailModel[i].email,
          phone: _contactPersonDetailModel[i].phone,
          isMainPerson: _contactPersonDetailModel[i].isMainPerson,
          isArchived: _contactPersonDetailModel[i].isArchived ? true : false,
          contactSocialModel: [],
        };
        for (let count = 0; count < _contactPersonDetailModel[i].contactSocialModel.length; count++) {
          let contactSocial = {
            socialTypeId: _contactPersonDetailModel[i].contactSocialModel[count].socialTypeId,
            url: _contactPersonDetailModel[i].contactSocialModel[count].url,
          };
          contactPersonData.contactSocialModel.push(contactSocial);
        }
        contactPersonList.push(contactPersonData);
      }
      return contactPersonList;
    }
  },
  PrepareContactPerson(input) {
    let contactPersonDetailModel = {
      personalNamePrefixTypeId: input.prefixType,
      personalNamePrefixOther: input.contactOtherPrefix,
      firstname: input.firstname,
      lastname: input.lastname,
      nickname: input.nickname,
      position: input.position,
      phone: input.phone,
      email: input.email,
      departmentTypeId: input.departmentType.value,
      departmentOther: input.departmentOther,
      contactSocialModel: input.socialList,
    };
    if (input.contactPersonType === 1) {
      contactPersonDetailModel = {
        personalNamePrefixTypeId: input.prefixType,
        personalNamePrefixOther: input.contactOtherPrefix,
        firstname: input.firstname,
        lastname: input.lastname,
        nickname: input.nickname,
        phone: input.phone,
        email: input.email,
      };
    }
    return contactPersonDetailModel;
  },
  PrepareContactPersonForEdit(input) {
    let contactPersonDetailModel = {
      contactPersonId: input.contactPersonId,
      personalNamePrefixTypeId: input.prefixType,
      personalNamePrefixOther: input.contactOtherPrefix,
      firstname: input.firstname,
      lastname: input.lastname,
      nickname: input.nickname,
      position: input.position,
      phone: input.phone,
      email: input.email,
      departmentTypeId: input.departmentType.value,
      departmentOther: input.departmentOther,
      contactSocialModel: input.socialList,
      isMainPerson: input.isMainPerson,
    };
    if (input.contactPersonType === 1) {
      contactPersonDetailModel = {
        contactPersonId: input.contactPersonId,
        personalNamePrefixTypeId: input.prefixType,
        personalNamePrefixOther: input.contactOtherPrefix,
        firstname: input.firstname,
        lastname: input.lastname,
        nickname: input.nickname,
        phone: input.phone,
        email: input.email,
        isMainPerson: input.isMainPerson,
      };
    }
    return contactPersonDetailModel;
  },
  ContactDashBoardTableListModel(transactionList, expire) {
    let transactionModel = [];
    if (transactionList !== null) {
      for (let count = 0; count < transactionList.length; count++) {
        let transactionItem = transactionList[count];
        let transaction = {};
        if (expire && transactionItem.status === 0) {
          if (transactionItem.datetimeNow > transactionItem.duedate) {
            transaction = {
              id: transactionItem.id,
              number: transactionItem.number,
              date: transactionItem.date,
              duedate: transactionItem.duedate,
              netAmount: transactionItem.netAmount,
              beforeDueDate: transactionItem.beforeDueDate,
              status: transactionItem.status,
            };
            transactionModel.push(transaction);
          }
        } else {
          transaction = {
            id: transactionItem.id,
            number: transactionItem.number,
            date: transactionItem.date,
            duedate: transactionItem.duedate,
            netAmount: transactionItem.netAmount,
            beforeDueDate: transactionItem.beforeDueDate,
            status: transactionItem.status,
          };
          transactionModel.push(transaction);
        }
      }
    }
    return transactionModel;
  },
  PrepareFavoriteContact(input) {
    let favoriteTypeId = Enums.FavoriteType.None;
    switch (input.transactionTypeId) {
      case Enums.TransactionType.Quotation:
        favoriteTypeId =
          input.financeTypeId === Enums.FinanceType.InFlow
            ? Enums.FavoriteType.Quotation
            : Enums.FavoriteType.PurchaseOrder;
        break;
      case Enums.TransactionType.Invoice:
        if (input.expenseTypeId === Enums.ExpenseType.None) {
          favoriteTypeId = Enums.FavoriteType.Invoice;
        } else if (input.expenseTypeId === Enums.ExpenseType.Expense) {
          favoriteTypeId = Enums.FavoriteType.ExpenseRecord;
        } else if (input.expenseTypeId === Enums.ExpenseType.PurchaseInventory) {
          favoriteTypeId = Enums.FavoriteType.PurchaseInventoryRecord;
        } else {
          favoriteTypeId = Enums.FavoriteType.PurchaseAsset;
        }
        break;
      case Enums.TransactionType.Receipt:
        favoriteTypeId = Enums.FavoriteType.Receipt;
        break;
      case Enums.TransactionType.TaxInvoice:
        favoriteTypeId =
          input.financeTypeId === Enums.FinanceType.InFlow
            ? Enums.FavoriteType.TaxInvoice
            : Enums.FavoriteType.PurchaseTaxInvoice;
        break;
      case Enums.TransactionType.CreditNote:
        favoriteTypeId =
          input.financeTypeId === Enums.FinanceType.InFlow
            ? Enums.FavoriteType.CreditNote
            : Enums.FavoriteType.ReceiveCreditNote;
        break;
      case Enums.TransactionType.BillingNote:
        favoriteTypeId =
          input.financeTypeId === Enums.FinanceType.InFlow
            ? Enums.FavoriteType.BillingNote
            : Enums.FavoriteType.CombinedPaymentNote;
        break;
    }
    let favoriteContactInput = {
      contactId: input.contactId,
      favoriteTypeId: favoriteTypeId,
    };
    return favoriteContactInput;
  },
};
